












import { Component, Vue } from 'vue-property-decorator';
import { workspaceService } from '@/services/WorkspaceService';
import { accountService } from '@/services/AccountService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';

@Component({
  components: {
    PriceWithCurrency,
  },
})
export default class CardGoToPanelDialog extends Vue {
  isModalShown = true;
  workspaceId = 0;
  workspace: any = {};
  amount: any = null;
  currency: any = null;

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    workspaceService
      .getWorkspaces()
      .then((data: any) => {
        this.workspace = data.workspaces.filter((item: any) => item.id === this.workspaceId)[0];
      })
      .catch(() => {});
    accountService.getBalance(this.workspaceId).then(data => {
      this.amount = data.balance === 0 ? 0 : data.balance / 100;
      this.currency = data.currency;
    });
  }
  onClose() {
    this.isModalShown = false;
  }
}
